import { gsap } from 'gsap';

export type TimelineWithPosition = { tl: gsap.core.Timeline, position?: gsap.Position };
export type TimelineExt = gsap.core.Timeline | TimelineWithPosition;

export function combineTimelines(vars: gsap.TimelineVars, ...timelines: TimelineExt[]) {
    const tl = gsap.timeline(vars);
    timelines.forEach(t => {
        if (t instanceof gsap.core.Timeline) {
            tl.add(t);
        } else {
            if (t.position != null) {
                tl.add(t.tl, t.position);
            } else {
                tl.add(t.tl);
            }
        }
    });
    return tl;
}
